import { authApiClient } from '@/services/axios'
import { collectDeviceInfo } from '@/utils/deviceInfo'

interface DeviceLogData {
  device_id: string
  device_os: string
  device_name: string
}

class DeviceLogsService {
  private readonly endpoint = '/device-logs'

  /**
   * Logs device information after successful login
   * This is called after authentication is completed
   */
  async logDeviceLogin(): Promise<void> {
    try {
      const deviceInfo = collectDeviceInfo()
      
      const payload: { data: DeviceLogData } = {
        data: {
          device_id: deviceInfo.device_id,
          device_os: deviceInfo.device_os,
          device_name: deviceInfo.device_name
        }
      }

      await authApiClient.post(this.endpoint, payload)
      
      console.log('Device login logged successfully', deviceInfo)
    } catch (error) {
      // Don't throw error - this should not block the login process
      console.warn('Failed to log device login:', error)
    }
  }
}

export const deviceLogsService = new DeviceLogsService()